import Link from 'next/link';
import { Button } from '@carvana/helios-navigation/button';
import useAnalyticEvent, { PageName } from '../../../hooks/useAnalyticEvent';
import { APP_BASE_PATH } from '../../../shared/appBasePath';
import { EventActions } from '../../../analytics/uiMetrics';

import { GetValueContainer, Heading } from './GetValueModule.styles';

const getValueRoute = `${APP_BASE_PATH}/get-value/vehicle`;

const GetValueModule = () => {
  const { recordEventAndNavigate } = useAnalyticEvent();

  const handleClick = e => {
    e.currentTarget.href = getValueRoute;
    recordEventAndNavigate(e, PageName.Marketing, 'Value Module', {
      event: EventActions.Clicked
    });
  };

  return (
    <GetValueContainer>
      <Heading>See how your value compares to similar vehicles</Heading>
      <Link href={getValueRoute} onClick={handleClick} prefetch={false}>
        <Button variant="primaryInverted" as="div">
          Get My Value
        </Button>
      </Link>
    </GetValueContainer>
  );
};

export default GetValueModule;
